import React from 'react';

// Infinite horizontal marquee. Duplicates children for a seamless loop.
export default function Marquee({ items, renderItem, className = '' }) {
  return (
    <div className={`relative overflow-hidden ${className}`}>
      <div className="flex w-max marquee-track gap-4">
        {[...items, ...items].map((item, i) => (
          <div key={i} className="shrink-0">{renderItem(item, i)}</div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent" />
    </div>
  );
}
